export default {
  modulos: [],
  isLoading: false
}
